/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:41:55
 */
const s = {
    ballDistance: 26.15,
    diameter: 13.5,
    numRows: 10,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [321.4865801443546, 322.4376307498037, 319.31818231847745, 361.42214036995455, 319.34672147405945, 323.0611623049249, 321.88814163507493, 320.6849141556435],
        1: [362.81064290802414, 321.7531385202233, 360.56649738237815, 322.09572152564976, 361.5422134203011, 319.94836462842744, 323.0804101676883, 362.46233835748495],
        2: [322.22540743611785, 322.0714056021798, 322.62218634601703, 319.4754916582792, 321.4856610488362, 320.78167695265756, 319.79754916217126, 359.73735060644947],
        3: [321.08974002059813, 319.5363762960499, 319.4635590768281, 362.6497513475237, 362.7691727466651, 321.29831579340294, 319.3429401686372, 360.3249478318903],
        4: [360.31958896512447, 361.558365806825, 362.6280964277041, 361.6500141294388, 359.307285146132, 361.59964251585995, 359.1919453866837, 361.6877321883123],
        5: [319.2186218310392, 319.98036063950224, 359.0999699796772, 321.0109705698236, 321.0255663315523, 359.8481533983359, 362.4479814557647, 362.18352762951747],
        6: [319.9128938324725, 323.16240349438294, 322.88968078503, 323.16723214302965, 362.5577582259554, 359.3680624192822, 322.9385884560268, 321.6805936964292],
        7: [360.61443479023836, 321.2920319351289, 319.19282468192534, 362.62028900572534, 358.9738136862702, 360.27312547415465, 320.8386053344053, 361.84794178861836],
        8: [360.2767712973802, 361.32471918897306, 319.19166116953306, 359.926017517165, 322.9181026440162, 359.18570107072156, 320.7944116269431, 360.9266417259876],
        9: [360.03554559452624, 362.442933563689, 321.4544169543165, 359.61183866557565, 362.42219242083667, 361.3148539233268, 321.29603526598885, 321.42562322567534],
        10: [360.20451641569673, 360.7277185756386, 360.01193662203866, 360.2870405239594, 320.505469358338, 359.4290145328316, 362.0516573663089, 358.8421505232256],
        11: []
    }
};
export {s as default};
